import { CandleProduct, Review, SceneMeta } from '../types';

export const SCENES: SceneMeta[] = [
  { id: 'darkness', index: 1, title: 'I. The Silence', subhead: 'Before the spark', scrollStart: 0.0, scrollEnd: 0.07 },
  { id: 'ignition', index: 2, title: 'II. The Ignition', subhead: 'Warmth awakens', scrollStart: 0.07, scrollEnd: 0.14 },
  { id: 'logo_title', index: 3, title: 'III. Light a Moment', subhead: 'Noor Pieces by Rashmi', scrollStart: 0.14, scrollEnd: 0.21 },
  { id: 'into_flame', index: 4, title: 'IV. Through the Light', subhead: 'Entering the flame', scrollStart: 0.21, scrollEnd: 0.28 },
  { id: 'molten_core', index: 5, title: 'V. Molten Alchemy', subhead: 'Pure soy wax & golden oils', scrollStart: 0.28, scrollEnd: 0.35 },
  { id: 'workshop', index: 6, title: 'VI. Rashmi’s Workshop', subhead: 'Crafted by patient hands', scrollStart: 0.35, scrollEnd: 0.42 },
  { id: 'ingredients', index: 7, title: 'VII. Earth & Essence', subhead: 'Sustainably sourced botanical notes', scrollStart: 0.42, scrollEnd: 0.50 },
  { id: 'assembly', index: 8, title: 'VIII. The Creation', subhead: 'Hand poured in small batches', scrollStart: 0.50, scrollEnd: 0.57 },
  { id: 'scent_realms', index: 9, title: 'IX. Scent Worlds', subhead: 'Vanilla, Lavender, Coffee & Rose', scrollStart: 0.57, scrollEnd: 0.65 },
  { id: 'gallery', index: 10, title: 'X. Masterpiece Gallery', subhead: 'The Noor Pieces Collection', scrollStart: 0.65, scrollEnd: 0.74 },
  { id: 'interiors', index: 11, title: 'XI. Living Spaces', subhead: 'Transforming home atmosphere', scrollStart: 0.74, scrollEnd: 0.82 },
  { id: 'unboxing', index: 12, title: 'XII. The Unboxing', subhead: 'A gift of slow living', scrollStart: 0.82, scrollEnd: 0.89 },
  { id: 'reviews', index: 13, title: 'XIII. Illuminated Words', subhead: 'Letters from quiet homes', scrollStart: 0.89, scrollEnd: 0.95 },
  { id: 'final_warmth', index: 14, title: 'XIV. Bring Warmth Home', subhead: 'Begin your ritual', scrollStart: 0.95, scrollEnd: 1.0 },
];

export const CANDLE_COLLECTION: CandleProduct[] = [
  {
    id: 'santal-golden-flame',
    name: 'Santal & Golden Flame',
    tagline: 'Deep woody warmth and grounding cardamom smoke.',
    description: 'Hand-poured into thick smoky amber glass. Infused with wild-harvested Australian sandalwood, crushed cardamom pods, and golden amber resins. Designed for evening reflection.',
    topNotes: ['Crushed Cardamom', 'Violet Leaf', 'Cypress'],
    heartNotes: ['Australian Sandalwood', 'Papyrus', 'Iris'],
    baseNotes: ['Amber Resin', 'Smoked Leather', 'Cedarwood'],
    burnTime: '55 - 60 Hours',
    weight: '280g / 9.8 oz',
    waxType: '100% Pure Soy & Coconut Wax Blend',
    wickType: 'Unbleached Organic Cotton Wick',
    mood: 'Deep Serenity & Focus',
    price: 68,
    colorHex: '#d4a373',
    flameColorHex: '#ffaa33',
    accentColor: 'from-amber-700 to-amber-900',
    imageBg: 'linear-gradient(135deg, #2b1e17 0%, #17100b 100%)',
    vibeStory: 'A quiet evening in a timber cabin as rain taps against the glass. Earthy, velvet, and eternal.',
    productImage: 'https://images.unsplash.com/photo-1603006905003-be475563bc59?auto=format,compress&fit=crop&w=800&q=75&fm=webp'
  },
  {
    id: 'velvet-vanilla-cashmere',
    name: 'Velvet Vanilla & Cashmere',
    tagline: 'Madagascar orchid vanilla and warm whipped tonka bean.',
    description: 'Not sweet, but sophisticated and dark. Rich vanilla beans steeped in warm oak casks with notes of cashmere wool, golden honey, and soft musk.',
    topNotes: ['Orchid Blossom', 'Caramelized Sugar', 'Almond Milk'],
    heartNotes: ['Madagascar Bourbon Vanilla', 'Heliotrope', 'Warm Tonka'],
    baseNotes: ['White Cashmere', 'Smoky Oak', 'Musk'],
    burnTime: '50 - 55 Hours',
    weight: '270g / 9.5 oz',
    waxType: '100% Pure Soy Wax',
    wickType: 'Double Crackling Wood Wick',
    mood: 'Nostalgic Comfort & Wholeness',
    price: 64,
    colorHex: '#f3d5b5',
    flameColorHex: '#ffd166',
    accentColor: 'from-orange-600 to-amber-800',
    imageBg: 'linear-gradient(135deg, #3d2b1f 0%, #1f140e 100%)',
    vibeStory: 'Wrapping yourself in a soft cashmere blanket on Sunday morning while fresh snowfall covers the world outside.',
    productImage: 'https://images.unsplash.com/photo-1608571423902-eed4a5ad8108?auto=format,compress&fit=crop&w=800&q=75&fm=webp'
  },
  {
    id: 'lavender-fog-sea-salt',
    name: 'Lavender Fog & Wild Sage',
    tagline: 'High-altitude French lavender steeped in morning mist.',
    description: 'Harvested from steep Provence mountainsides at dawn. Blended with clary sage, wild sea salt, and damp driftwood to calm overactive minds.',
    topNotes: ['Wild Sea Salt', 'Eucalyptus Fog', 'Clary Sage'],
    heartNotes: ['Highland French Lavender', 'Rosemary', 'Thyme'],
    baseNotes: ['Coastal Driftwood', 'White Amber', 'Clean Cotton'],
    burnTime: '52 - 58 Hours',
    weight: '280g / 9.8 oz',
    waxType: '100% Botanical Soy Wax',
    wickType: 'Unbleached Organic Cotton Wick',
    mood: 'Restful Sleep & Peaceful Mind',
    price: 62,
    colorHex: '#b8c0e0',
    flameColorHex: '#e0aaff',
    accentColor: 'from-purple-800 to-slate-900',
    imageBg: 'linear-gradient(135deg, #1c1b29 0%, #0d0c14 100%)',
    vibeStory: 'Standing atop a cliff above a misty coastline as cool breezes wash away the thoughts of the day.',
    productImage: 'https://images.unsplash.com/photo-1598501488500-34a942a03305?auto=format,compress&fit=crop&w=800&q=75&fm=webp'
  },
  {
    id: 'midnight-espresso-woodsmoke',
    name: 'Midnight Espresso & Oak',
    tagline: 'Fresh roasted Arabica beans, dark cacao, and embers.',
    description: 'An invigorating dark blend for night owls and early risers. Smoked dark roast beans accord layered with raw cacao nibs and charred birch wood.',
    topNotes: ['Dark Roasted Arabica', 'Crushed Cinnamon', 'Nutmeg'],
    heartNotes: ['Raw Cacao Nibs', 'Roasted Hazelnut', 'Espresso Foam'],
    baseNotes: ['Charred Birch', 'Smoked Vanilla', 'Golden Oud'],
    burnTime: '58 - 62 Hours',
    weight: '290g / 10.2 oz',
    waxType: '100% Pure Soy Wax',
    wickType: 'Single Crackling Wood Wick',
    mood: 'Creative Energy & Warm Intimacy',
    price: 66,
    colorHex: '#805b10',
    flameColorHex: '#f48c06',
    accentColor: 'from-stone-800 to-zinc-950',
    imageBg: 'linear-gradient(135deg, #241710 0%, #0c0805 100%)',
    vibeStory: 'Late night conversation over black coffee in a dimly lit library filled with old leather-bound books.',
    productImage: 'https://images.unsplash.com/photo-1572635196237-14b3f281503f?auto=format,compress&fit=crop&w=800&q=75&fm=webp'
  },
  {
    id: 'sunset-rose-smoked-oud',
    name: 'Sunset Rose & Smoked Oud',
    tagline: 'Velvet Damask rose petals kissed by rare agarwood smoke.',
    description: 'Opulent, mysterious, and deeply romantic. Deep crimson rose petals steeped in smoked agarwood, wild honey, and dark praline.',
    topNotes: ['Damask Rose Petals', 'Pink Pepper', 'Wild Honey'],
    heartNotes: ['May Rose', 'Geranium', 'Smoked Oud'],
    baseNotes: ['Dark Amber', 'Patchouli', 'Praline Wood'],
    burnTime: '60 - 65 Hours',
    weight: '300g / 10.5 oz',
    waxType: '100% Botanical Soy & Beeswax Blend',
    wickType: 'Dual Cotton Wicks',
    mood: 'Romantic Opulence & Luxury',
    price: 72,
    colorHex: '#e63946',
    flameColorHex: '#ff4d6d',
    accentColor: 'from-rose-950 to-neutral-950',
    imageBg: 'linear-gradient(135deg, #331219 0%, #120508 100%)',
    vibeStory: 'Golden twilight over an ancient palace courtyard. Warm air carries the fragrance of blooming gardens.',
    productImage: 'https://images.unsplash.com/photo-1517841905240-472988babdf9?auto=format,compress&fit=crop&w=800&q=75&fm=webp'
  }
];

export const INGREDIENTS = [
  { name: '100% Pure Soy Wax', origin: 'Renewable Iowa Agriculture', desc: 'Clean burning, non-toxic, slow melting formula with zero soot.' },
  { name: 'Organic Cotton Wick', origin: 'Unbleached & Lead-Free', desc: 'Engineered for a consistent flame, soft crackle, and steady glow.' },
  { name: 'Madagascar Bourbon Vanilla', origin: 'Sustainably Hand-Pollinated', desc: 'Cured in wooden casks for deep orchid sweetness.' },
  { name: 'Single-Origin Arabica', origin: 'Ethically Sourced Ethiopian Highlands', desc: 'Roasted slowly to capture rich essential oils.' },
  { name: 'Provence High-Altitude Lavender', origin: 'French Alps Distillation', desc: 'Distilled at dawn for highest calm-inducing botanical compounds.' },
  { name: 'Damask Velvet Rose', origin: 'Valley of Roses, Bulgaria', desc: 'Gathered by hand before the morning dew evaporates.' },
  { name: 'Australian Sandalwood', origin: 'Certified Sustainable Plantations', desc: 'Aged 30 years for rich, creamy, resinous heartwood.' }
];

export const REVIEWS: Review[] = [
  {
    id: 'r1',
    author: 'Eleanor Vance',
    location: 'Kyoto, Japan',
    quote: 'When I light Noor at twilight, my entire home shifts into a monastery of quiet peace. Rashmi’s craftsmanship is palpable in every flicker.',
    rating: 5,
    candleName: 'Santal & Golden Flame',
    handwrittenDate: 'October 14, 2025'
  },
  {
    id: 'r2',
    author: 'Marcus & Julian',
    location: 'Zurich, Switzerland',
    quote: 'This is not just a candle. It is an anchor for our evening ritual. The scent doesn’t overpower; it gently embraces the room like memory.',
    rating: 5,
    candleName: 'Velvet Vanilla & Cashmere',
    handwrittenDate: 'November 2, 2025'
  },
  {
    id: 'r3',
    author: 'Dr. Sarah Lin',
    location: 'Oxford, United Kingdom',
    quote: 'After 12-hour hospital shifts, lighting Lavender Fog is my signal to breathe again. I have given twelve as gifts this year.',
    rating: 5,
    candleName: 'Lavender Fog & Wild Sage',
    handwrittenDate: 'December 19, 2025'
  },
  {
    id: 'r4',
    author: 'Clara Dubois',
    location: 'Paris, France',
    quote: 'The unboxing felt like receiving a love letter from a master artisan. You can feel Rashmi’s patience in the heavy glass and flawless burn.',
    rating: 5,
    candleName: 'Sunset Rose & Smoked Oud',
    handwrittenDate: 'January 8, 2026'
  }
];

export const INTERIORS = [
  {
    id: 'bedroom',
    title: 'The Sanctuary Bedchamber',
    quote: 'Where the day softly untangles and evening stillness settles.',
    candleName: 'Velvet Vanilla & Cashmere',
    ambienceColor: '#2d1b12'
  },
  {
    id: 'bathroom',
    title: 'The Soaking Atelier',
    quote: 'Warm steam carrying botanical lavender over white marble.',
    candleName: 'Lavender Fog & Wild Sage',
    ambienceColor: '#171c2b'
  },
  {
    id: 'reading',
    title: 'The Private Library',
    quote: 'Distant rain outside, amber glass glowing beside leather volumes.',
    candleName: 'Santal & Golden Flame',
    ambienceColor: '#241a12'
  },
  {
    id: 'dining',
    title: 'The Intimate Gathering Table',
    quote: 'Shared laughter, low fire light, and lingering conversation.',
    candleName: 'Midnight Espresso & Oak',
    ambienceColor: '#21130d'
  }
];
